import { Container, Row } from 'react-bootstrap'
import DiscoverSection from '../../components/user/DiscoverSection'

const Featured = () => {
  return (
    <Container>
      <Row className='ps-3 pe-3'>
        <DiscoverSection alias={'featured'} title={'Featured'} />
      </Row>
      <Row className='ps-3 pe-3'>
        <DiscoverSection alias={'revhigh'} title={'Thrashing'} />
      </Row>
      <Row className='ps-3 pe-3'>
        <DiscoverSection alias={'zfsound'} title={'ZF Ecomat'} />
      </Row>
      <Row className='ps-3 pe-3'>
        <DiscoverSection
          alias={'mmcsleep'}
          title={'Fall asleep to ZF Enviro500 MMC'}
        />
      </Row>
    </Container>
  )
}
export default Featured
